module.exports = __webpack_public_path__ + "img/login_pop_logo.ae618636.png";